import { Dispatch, RefObject, SetStateAction } from "react";
import { Menuitem } from "../../../../../interfaces/Security/menu";
import GradingIcon from '@mui/icons-material/Grading';
import { AlertColor } from "@mui/material";
import { PrimaryButton } from "../../../../../theme/buttons";
import { useTranslation } from "react-i18next";
import NotificationAddIcon from '@mui/icons-material/NotificationAdd';
import { GridColDef, GridValidRowModel } from "@mui/x-data-grid";
import { TableCurrencyCompany } from "../../../../../components/Tables/TableCurrencyCompany/tableCurrencies";
import { FilterTable, FilterTableRef } from "../../../../../components/Filter";
import { PaymentDetail } from "../../../../../interfaces/Purchases/Payments/payments";

type TableApplyPaymentProps = {
    resourceScreen: Menuitem | undefined
    dataCurrencyTable: MyTableCurrencyBanks[];
    setDataCurrencyTable: Dispatch<SetStateAction<MyTableCurrencyBanks[]>>;
    setBackDropLoading: Dispatch<SetStateAction<boolean>>;
    setMessageSnack: Dispatch<SetStateAction<string>>;
    setUnauthorized: Dispatch<SetStateAction<boolean>>;
    showSnackBar: (message: string, severity: AlertColor) => void;
    selectedRows: readonly GridValidRowModel[],
    resourceAuthorizePayments: Menuitem | undefined,
    setDialogPayment: Dispatch<SetStateAction<boolean>>,
    setOpenDialogAddNotification: Dispatch<SetStateAction<boolean>>,
    setIsLoadingData: Dispatch<SetStateAction<boolean>>,
    initFilter: string,
    defaultFilter: {
        idFilter: number;
        column: string;
        operator: string;
        value: string;
    }[],
    setPaymentsDetailsData: Dispatch<SetStateAction<readonly GridValidRowModel[]>>,
    columnsAuthorizationPayments: GridColDef<PaymentDetail>[],
    onApplyFilter: ((filter: any) => void) | null | undefined,
    refTableFilter: RefObject<FilterTableRef>,
}

interface MyTableCurrencyBanks {
    currency_id: number,
    currency_code: string,
    currency_description: string,
    balanceBankAccount: number,
    balanceAutorized: number,
    balanceFree: number,
    exchangeRate: number,
    active: boolean,
}

export const HeaderAuthorizationPayment = ({
    resourceScreen,
    dataCurrencyTable,
    setDataCurrencyTable,
    setBackDropLoading,
    setMessageSnack,
    setUnauthorized,
    showSnackBar,
    selectedRows,
    resourceAuthorizePayments,
    setDialogPayment,
    setOpenDialogAddNotification,
    setIsLoadingData,
    initFilter,
    defaultFilter,
    setPaymentsDetailsData,
    columnsAuthorizationPayments,
    onApplyFilter,
    refTableFilter,
}: TableApplyPaymentProps) => {
    const [t] = useTranslation("global");

    return (
        <>
            <TableCurrencyCompany
                resourceScreen={resourceScreen}
                dataCurrencyTable={dataCurrencyTable}
                setDataCurrencyTable={setDataCurrencyTable}
                setBackDropLoading={setBackDropLoading}
                setMessageSnack={setMessageSnack}
                setUnauthorized={setUnauthorized}
                showSnackBar={showSnackBar}
            />
            <div className="w-100 d-flex flex-row mt-2 align-items-center justify-content-between">
                <div className="w-50 mt-2">
                    <h3>{t("authorizationpayments.title")}</h3>
                </div>
                <div className="w-75 d-flex flex-row-reverse align-items-center">
                    <div className='w-25 mt-2'>
                        <PrimaryButton size="small" variant='outlined' className="m-1" sx={{ width: "100%", height: "90%", color: 'primary.main' }} disabled={(selectedRows?.length === 0) || !resourceAuthorizePayments?.create} onClick={() => setDialogPayment(true)}>
                            {t("authorizationpayments.buttons.authorize-payments")}
                            <GradingIcon sx={{ marginLeft: 1 }} />
                        </PrimaryButton>
                    </div>
                    <div className='w-25 mt-2 mx-2'>
                        <PrimaryButton size="small" variant='outlined' className="m-1" sx={{ width: "100%", height: "90%", color: 'primary.main' }} disabled={(selectedRows?.length === 0) || !resourceAuthorizePayments?.create} onClick={() => setOpenDialogAddNotification(true)}>
                            {t("authorizationpayments.buttons.not-authorize")}
                            <NotificationAddIcon />
                        </PrimaryButton>
                    </div>
                    <div className=''>
                        <FilterTable
                            ref={refTableFilter}
                            setIsLoadingDataTable={setIsLoadingData}
                            setDataTable={setPaymentsDetailsData}
                            showSnackBar={showSnackBar}
                            columnsTable={columnsAuthorizationPayments}
                            initFilter={initFilter}
                            resourceRoute="/authorizationpayments"
                            defaultFilter={defaultFilter}
                            onApplyFilter={onApplyFilter}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}